module.exports = __webpack_public_path__ + "poppins-medium_0-webfont.db58a573c4129fa2a40d.woff";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-medium_0-webfont.woff
// module id = ../../../../../src/assets/fonts/poppins-medium_0-webfont.woff
// module chunks = 2